import React, { useContext, useEffect } from 'react';
import { connect } from 'react-redux';

import { makeGetUser, makeGetCurrentUserId } from 'selectors/users';
import { makeGetCurrentTeam } from '../selectors/teams';

import { fetchUser } from 'actions/users';

import { extractId } from 'utils/helpers';

import { RolesAndPermissionsContext } from 'context/RolesAndPermissionsContext';

import Avatar from './avatar';

const UserAvatar = ({ id, user, ...props }) => {
    const rolesAndPermissions = useContext(RolesAndPermissionsContext);

    useEffect(() => {
        if (!user && id) {
            fetchUser(id);
        }
    }, [id, user]);

    if (!user) {
        return null;
    }

    return (
        <Avatar
            id={id}
            name={user.name}
            role={rolesAndPermissions?.getRoleId(user)}
            pending={user.pending}
            image={user.avatar}
            timezone={user.tz_offset}
            email={user.email}
            text={user.initials}
            color={user.color}
            foregroundColor={user.secondary_color}
            removed={user.removed}
            online={user.online}
            available={user.available}
            loading={user.loading}
            {...props}
        />
    )
}

const makeMapStateToProps = () => {
    const getUser = makeGetUser();
    const getCurrentUserId = makeGetCurrentUserId();
    const getCurrentTeam = makeGetCurrentTeam();

    return ({ users, teams }, ownProps) => {
        const id = extractId(ownProps.id);

        return {
            id,
            user: getUser(users, id),
            currentUserId: getCurrentUserId(users)
        };
    };
}

export default connect(makeMapStateToProps)(UserAvatar);
